<div class="space-y-4">
  <p class="text-xs text-gray-500 dark:text-gray-400">Secuencia de correos que se envían automáticamente antes de la reunión para preparar al invitado.</p>

  <!-- Alta -->
  <div class="p-3 rounded-lg border border-gray-200 dark:border-gray-700 space-y-3">
    <div class="grid grid-cols-1 md:grid-cols-[auto_1fr_auto] gap-2">
      <div>
        <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Enviar (horas antes)</label>
        <input type="number" min="0" [(ngModel)]="newDelayHours" placeholder="24"
          class="w-28 px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
      </div>
      <div>
        <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Asunto</label>
        <input type="text" [(ngModel)]="newSubject"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
      </div>
      @if (templates.length > 0) {
        <div>
          <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Usar plantilla</label>
          <select [ngModel]="newTemplateId" (ngModelChange)="applyNewTemplate($event)"
            class="w-48 px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
            <option [ngValue]="null">— Sin plantilla —</option>
            @for (t of templates; track t.id) { <option [ngValue]="t.id">{{ t.name }}</option> }
          </select>
        </div>
      }
    </div>
    <div>
      <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Cuerpo del correo</label>
      <app-rich-text-editor
        [value]="newBodyHtml"
        (valueChange)="newBodyHtml = $event"
        [variableNamespaces]="variableNamespaces"
        minHeight="200px"
        placeholder="Escribe el contenido del correo…"></app-rich-text-editor>
    </div>
    <button type="button" (click)="add()" [disabled]="saving || newDelayHours === null || !newSubject.trim()"
      class="px-3 py-1.5 text-sm rounded-lg font-medium bg-brand-500 text-white hover:bg-brand-600 disabled:opacity-50">
      + Agregar correo
    </button>
  </div>

  @if (loading) {
    <p class="text-sm text-gray-500 dark:text-gray-400">Cargando...</p>
  } @else if (items.length === 0) {
    <p class="text-sm text-gray-500 dark:text-gray-400">No hay emails configurados.</p>
  } @else {
    <ul class="space-y-3">
      @for (item of items; track item.id) {
        <li class="rounded-lg border border-gray-200 dark:border-gray-700 p-3">
          @if (editingId === item.id) {
            <!-- Modo edición -->
            <div class="space-y-2">
              <div class="grid grid-cols-1 md:grid-cols-[auto_1fr_auto] gap-2">
                <input type="number" min="0" [(ngModel)]="editDelayHours"
                  class="w-24 px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
                <input type="text" [(ngModel)]="editSubject"
                  class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
                @if (templates.length > 0) {
                  <select [ngModel]="editTemplateId" (ngModelChange)="applyEditTemplate($event)"
                    class="w-44 px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
                    <option [ngValue]="null">— Usar plantilla —</option>
                    @for (t of templates; track t.id) { <option [ngValue]="t.id">{{ t.name }}</option> }
                  </select>
                }
              </div>
              <app-rich-text-editor
                [value]="editBodyHtml"
                (valueChange)="editBodyHtml = $event"
                [variableNamespaces]="variableNamespaces"
                minHeight="200px"
                placeholder="Escribe el contenido del correo…"></app-rich-text-editor>
              <div class="flex items-center gap-2">
                <button type="button" (click)="saveEdit(item)"
                  class="text-xs px-2 py-1 rounded bg-brand-500 text-white hover:bg-brand-600">Guardar</button>
                <button type="button" (click)="cancelEdit()"
                  class="text-xs px-2 py-1 rounded border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300">Cancelar</button>
              </div>
            </div>
          } @else {
            <div class="flex items-start justify-between gap-3">
              <div class="min-w-0 flex-1">
                <div class="flex items-center gap-2 flex-wrap mb-1">
                  <span class="text-xs px-2 py-0.5 rounded bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300">{{ item.delayHours }}h antes</span>
                  @if (!item.isActive) { <span class="text-xs px-2 py-0.5 rounded bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300">inactivo</span> }
                </div>
                <p class="text-sm font-medium text-gray-900 dark:text-white">{{ item.subject }}</p>
                <p class="text-xs text-gray-500 dark:text-gray-400 mt-1 line-clamp-2">{{ bodyPreview(item.bodyHtml) }}</p>
              </div>
              <div class="flex items-center gap-2 flex-shrink-0">
                <button type="button" (click)="startEdit(item)"
                  class="text-xs px-2 py-1 rounded border border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300">
                  Editar
                </button>
                <button type="button" (click)="toggle(item)"
                  class="text-xs px-2 py-1 rounded border border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300">
                  {{ item.isActive ? 'Desactivar' : 'Activar' }}
                </button>
                <button type="button" (click)="remove(item)"
                  class="text-xs px-2 py-1 rounded border border-error-300 text-error-600 hover:bg-error-50">
                  Eliminar
                </button>
              </div>
            </div>
          }
        </li>
      }
    </ul>
  }
</div>
